const initTestimonialsSection = (section) => {
  const track = section.querySelector('.testimonials-track');
  const cards = Array.from(section.querySelectorAll('.testimonial-card'));
  const prevButton = section.querySelector('.carousel-btn-prev');
  const nextButton = section.querySelector('.carousel-btn-next');

  if (!track || cards.length === 0) return;

  const setButtonDisabled = (button, disabled) => {
    if (!button) return;
    if (disabled) {
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('disabled');
    }
  };

  const setState = () => {
    const orderedCards = Array.from(track.querySelectorAll('.testimonial-card'));
    orderedCards.forEach((card) => {
      card.classList.remove('is-active', 'is-peek');
    });

    if (orderedCards.length === 0) return;
    orderedCards[0].classList.add('is-active');
    if (orderedCards.length > 1) {
      orderedCards[1].classList.add('is-peek');
    }
  };

  if (cards.length < 2) {
    setState();
    setButtonDisabled(prevButton, true);
    setButtonDisabled(nextButton, true);
    return;
  }

  setState();

  let isAnimating = false;
  const slide = (direction) => {
    if (isAnimating) return;
    isAnimating = true;

    track.classList.add('is-sliding');

    window.setTimeout(() => {
      if (direction > 0) {
        const firstCard = track.firstElementChild;
        if (firstCard) {
          track.appendChild(firstCard);
        }
      } else {
        const lastCard = track.lastElementChild;
        if (lastCard) {
          track.insertBefore(lastCard, track.firstElementChild);
        }
      }

      track.classList.remove('is-sliding');
      setState();
      isAnimating = false;
    }, 1200);
  };

  if (prevButton) {
    prevButton.addEventListener('click', () => slide(-1));
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => slide(1));
  }
};

export const initTestimonialsSections = () => {
  const testimonialsSections = document.querySelectorAll('.testimonials-section');
  testimonialsSections.forEach((section) => initTestimonialsSection(section));
};

export const initWhyVideo = () => {
  const containers = document.querySelectorAll('.feature-image-video');
  containers.forEach((container) => {
    const video = container.querySelector('video');
    const button = container.querySelector('.video-play-btn');
    const iconUse = button?.querySelector('use');
    if (!video || !button || !iconUse) return;

    const playHref = iconUse.getAttribute('data-icon-play') || iconUse.getAttribute('href');
    const pauseHref = iconUse.getAttribute('data-icon-pause');

    const setState = (isPlaying) => {
      const href = isPlaying ? pauseHref : playHref;
      if (href) {
        iconUse.setAttribute('href', href);
        iconUse.setAttribute('xlink:href', href);
      }
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      container.classList.toggle('is-playing', isPlaying);
    };

    setState(false);

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => { });
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', () => setState(true));
    video.addEventListener('pause', () => setState(false));
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      video.play().catch(() => { });
    });
  });
};

export const initHeroGalleryVideo = () => {
  const containers = document.querySelectorAll('.gallery-img-top-4, .gallery-img-bottom-3, .gallery-img-top-2');
  containers.forEach((container) => {
    const video = container.querySelector('video');
    const button = container.querySelector('.hero-video-toggle');
    const iconUse = button?.querySelector('use');
    if (!video || !button || !iconUse) return;

    const playHref = iconUse.getAttribute('data-icon-play') || iconUse.getAttribute('href');
    const pauseHref = iconUse.getAttribute('data-icon-pause');

    const setState = (isPlaying) => {
      const href = isPlaying ? pauseHref : playHref;
      if (href) {
        iconUse.setAttribute('href', href);
        iconUse.setAttribute('xlink:href', href);
      }
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    };

    setState(!video.paused);

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => { });
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', () => setState(true));
    video.addEventListener('pause', () => setState(false));
  });
};

export const initHeroCtaScroll = () => {
  const triggers = document.querySelectorAll('[data-scroll-target]');
  if (!triggers.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  triggers.forEach((trigger) => {
    const targetSelector = trigger.getAttribute('data-scroll-target');
    if (!targetSelector) return;

    const target = document.querySelector(targetSelector);
    if (!target) return;

    trigger.addEventListener('click', (event) => {
      if (trigger.tagName === 'A') {
        event.preventDefault();
      }

      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }

      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });

      const focusTarget = () => {
        target.focus({ preventScroll: true });
      };

      if (prefersReducedMotion) {
        focusTarget();
      } else {
        window.setTimeout(focusTarget, 500);
      }

      if (targetSelector.startsWith('#')) {
        history.pushState(null, '', targetSelector);
      }
    });
  });
};
